import Vue from 'vue';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import { moduleIterator } from '../moduleUtils';

moduleIterator(require.context('@/components/global', true, /\.vue$/), (name, mod) => Vue.component(name, mod));

Vue.component('VuePerfectScrollbar', VuePerfectScrollbar);
